export interface DeviceMgtList {
  UsingStatus: number;
  Status: string;
  acode: number;
  account: string;
  BindType?: number;
  LicenseInfo?: number;
  BindSn?: string;
  Level: number;
  deviceName?: string;
  dcode?: number;
  deviceModel: string;
  LicenseNumber?: number;
  RegionId?: number;
  RegionName?: string;
  LastActiveTime?: number;
  LicenseType?: number;
  LicenseTypeStr?: string;
  InfoId?: number;
  PlanName: string;
}

export interface DeviceSettingList {
  dcode: number;
  acode?: number;
  RegionId: number;
  LicenseInfo?: number;
  LicenseType?: number;
  LicenseTypeStr?: string;
  LicenseNumber?: string;
  BindSn?: string;
  BindType?: number;
  InfoId?: number;
  Level?: number;
  UsingStatus?: number;
  Status?: string;
  LastActiveTime?: number;
  DeviceName?: string;
  CardType?: number;
  CardFWVersion?: string;
  CardDcode?: number;
  CardRegionCode?: number;
  Model?: string;
  CardSn?: string;
  PlanName: string;
  DeviceSubType: number;
  SourceType: number;
  DisplaySourceType?: number;
  CardModel?: string;
}

export interface DeviceSettingFilter {
  RegionId?: number;
}

export interface DeviceMgtDetail {
  acode?: number;
  dcode?: number;
  UsedLicense: DeviceUsedLicense[];
}

export interface DeviceUsedLicense {
  LastActiveTime: number;
  RemainDay: number;
  PeriodDay: number;
  OriginalPeriodDay: number;
  UsingStatus: number;
  LicenseInfo: number;
  Level: number;
  LicenseNumber: number;
  LicenseType: number;
  PlanName: string;
}
